import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import { initSentry, SentryErrorBoundary } from './lib/sentry';
import { installFunctionActingHeader } from './lib/actingContext';
import './styles/globals.css';

// Boot Sentry before the React tree mounts so the global error handlers
// catch render-time exceptions too. No-op if VITE_SENTRY_DSN is unset.
initSentry();

// Stamp the per-tab acting-customer header onto Netlify function calls
// (docs/ACTING-CONTEXT.md). Must run before any request fires.
installFunctionActingHeader();

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found in index.html');
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <SentryErrorBoundary
      fallback={
        <div className="p-6 text-sm text-slate-900">
          Something went wrong loading this page. The Brix team has been
          notified — please refresh, or reach out to{' '}
          <a className="text-brix-primary underline" href="mailto:service@brixbev.com">
            service@brixbev.com
          </a>{' '}
          if it keeps happening.
        </div>
      }
    >
      <App />
    </SentryErrorBoundary>
  </React.StrictMode>,
);
